module.exports = __webpack_public_path__ + "img/pencil.afa9b5a3.svg";